import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { syncStoreTabBottomNavMark } from '@/store/lib/storeBackNav'

/** Keeps bottom-nav tab entry in sync so tab pages hide the back button reliably. */
export function StoreTabNavSync() {
  const { pathname, state } = useLocation()

  useEffect(() => {
    syncStoreTabBottomNavMark(pathname, state)
  }, [pathname, state])

  return null
}
